import React from "react"
import styles from "./Contact.module.css"
import { MdPhone } from "react-icons/md"
import { MdEmail } from "react-icons/md"
import { FaFacebook } from "react-icons/fa"
import { FaInstagram } from "react-icons/fa"
import FadeInSection from "../FadeInSection/FadeInSection"

const Contact = () => (
  <div className={styles.container} id="contact-page">
    <div className={styles.content}>
      <FadeInSection>
        <div className={styles.description}>
          <h1 className="bigTitle">Contact Us</h1>
          <h2 className="smallTitle">Let's get in touch!</h2>
          <div className="line"></div>
        </div>
        <div className={styles.contactContainer}>
          <div className={styles.contactInfo}>
            <div className={styles.email}>
              <MdEmail fontSize="30px" />
              <a href="mailto:rightchoicerenos@gmail.com">
                rightchoicerenos@gmail.com
              </a>
            </div>
            <div className={styles.phoneContainer}>
              <div className={styles.phoneContact}>
                <p>Kenny</p>
                <div className={styles.phoneInfo}>
                  <MdPhone fontSize="30px" />
                  <a href="tel:+1613-725-7247">613-725-7247</a>
                </div>
              </div>
              <div className={styles.phoneContact}>
                <p>Maurice</p>
                <div className={styles.phoneInfo}>
                  <MdPhone fontSize="30px" />
                  <a href="tel:+1613-725-7247">613-725-7247</a>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.socialMedia}>
            <a
              href="https://www.facebook.com/pages/category/Local-Business/Right-Choice-Renovations-205996086771225/"
              alt="facebook"
            >
              <FaFacebook
                fontSize="50px"
                color="#4267b2"
                aria-label="Facebook"
                className={styles.icons}
              />
            </a>
            <a
              href="https://www.instagram.com/rightchoicereno_mk/"
              aria-label="Instagram"
            >
              <FaInstagram
                fontSize="50px"
                color="#000000"
                alt="instgram"
                className={styles.icons}
              />
            </a>
          </div>
        </div>
        <form
          name="contact-form"
          method="POST"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
        >
          <input type="hidden" name="bot-field" />
          <input type="hidden" name="form-name" value="contact-form" />
          <div className={styles.field}>
            <label htmlFor="name">Name</label>
            <input type="text" name="name" id="name" placeholder="John Smith" />
          </div>
          <div className={styles.field}>
            <label htmlFor="email">Email</label>
            <input
              type="text"
              name="email"
              id="email"
              placeholder="youremail@domain"
            />
          </div>
          <div className={styles.field}>
            <label htmlFor="message">Message</label>
            <textarea
              name="message"
              id="message"
              rows="6"
              placeholder="Hello"
            />
          </div>
          <ul className={styles.actions}>
            <li>
              <input
                type="reset"
                value="Clear"
                className="special"
                id={styles.clear}
              />
            </li>
            <li>
              <input
                type="submit"
                value="Send Message"
                className="special"
                id={styles.submit}
              />
            </li>
          </ul>
        </form>
      </FadeInSection>
    </div>
  </div>
)

export default Contact
